import React from 'react';
import { ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ConfirmButton, CancelButton } from './ConfirmModal.styles';

const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirmação",
    message,
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    confirmButtonColor = "#1a1a1a"
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <ModalOverlay onClick={handleCancel}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <ModalHeader>
                    <h3>{title}</h3>
                </ModalHeader>
                <ModalBody>
                    <p>{message}</p>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup>
                        <CancelButton onClick={handleCancel}>
                            {cancelText}
                        </CancelButton>
                        <ConfirmButton
                            onClick={handleConfirm}
                            color={confirmButtonColor}
                        >
                            {confirmText}
                        </ConfirmButton>
                    </ButtonGroup>
                </ModalFooter>
            </ModalContent>
        </ModalOverlay>
    );
};

export default ConfirmModal;